import type {FieldErrors} from "react-hook-form";

import type {GlitchtipDiagnostics} from "./diagnostics";

export type ProductTelemetryEventType =
  | "client_validation_failure"
  | "gps_fallback_used";

export type ProductTelemetryInput = {
  eventType: ProductTelemetryEventType;
  feature: string;
  operation?: string;
  sheetId?: string;
  fieldCount?: number;
  gpsSource?: string;
  hadDraft?: boolean;
  hadFiles?: boolean;
  validationFieldPaths?: string[];
  diagnostics?: GlitchtipDiagnostics;
};

/** No-op — product friction telemetry was removed from GlitchTip (use analytics if needed). */
export function trackProductTelemetry(_input: ProductTelemetryInput): void {}

/** No-op — GPS fallback success is expected recovery, not a GlitchTip defect. */
export function trackGpsFallbackUsed(_input: {
  feature: string;
  operation: string;
  gpsSource: string;
}): void {}

/** Intentionally no-op — form abandon is not tracked in GlitchTip. */
export function trackFormAbandon(
  _input: Omit<ProductTelemetryInput, "eventType"> & {
    hadDraft?: boolean;
    hadFiles?: boolean;
    fieldCount?: number;
  },
): void {}

export function countFieldErrors(errors: FieldErrors): number {
  let count = 0;
  const walk = (node: FieldErrors | undefined) => {
    if (!node || typeof node !== "object") return;
    for (const value of Object.values(node)) {
      if (value && typeof value === "object" && "message" in value && value.message) {
        count += 1;
      } else if (value && typeof value === "object") {
        walk(value as FieldErrors);
      }
    }
  };
  walk(errors);
  return count;
}

/** RHF `handleSubmit(onValid, onInvalid)` helper — validation friction is not sent to GlitchTip. */
export function createFormInvalidHandler(_input: {
  feature?: string;
  operation: string;
  sheetId?: string;
}) {
  return (_errors: FieldErrors) => {};
}
